
















import { AllGeeksSingleSelect } from '@/components';
import { AddGCoins, ImportGCoinsFromFile } from '@/components/admin-panel';
import { Geek, GeekItem } from '@/models';
import { GCoinsAdminActionForm } from '@/models/admin-panel';
import { GeeksBalance } from '@/models/gcoins';
import { typedStore, Actions } from '@/store';
import { ToastsService, resetModel } from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'AddGCoinsTab',
  components: {
    AddGCoins,
    ImportGCoinsFromFile,
  },
  data() {
    return {
      loader: {
        isRequestAddGCoinsPending: false,
        isRequestImportGCoinsFromFilePending: false,
      },
    };
  },
  computed: {
    loadingStatus(): boolean {
      return this.loader.isRequestImportGCoinsFromFilePending || this.loader.isRequestAddGCoinsPending;
    },
  },
  methods: {
    changeAddGCoinsLoaderStatus(status: boolean) {
      this.loader.isRequestAddGCoinsPending = status;
    },
    changeImportGCoinsFromFileLoaderStatus(status: boolean) {
      this.loader.isRequestImportGCoinsFromFilePending = status;
    },
  },
});
